import React from 'react';

/**
 * Visual countdown timer for OSMD render operations
 * Shows a circular progress indicator when renders are pending
 */
const RenderTimer = ({ isActive, timeRemaining, progress, totalTime = 1500 }) => {
  if (!isActive) {
    return null;
  }

  // Calculate circle properties for SVG progress indicator
  const radius = 12;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference * (1 - progress);

  return (
    <div className="render-timer">
      <div className="render-timer-content">
        <svg className="render-timer-circle" width="28" height="28">
          {/* Background circle */}
          <circle
            cx="14"
            cy="14"
            r={radius}
            fill="none"
            stroke="rgba(255, 255, 255, 0.2)"
            strokeWidth="2"
          />
          {/* Progress circle */}
          <circle
            cx="14"
            cy="14"
            r={radius}
            fill="none"
            stroke="#4CAF50"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 14 14)"
            style={{
              transition: 'stroke-dashoffset 0.05s ease-out'
            }}
          />
        </svg>
        <span className="render-timer-text">
          {Math.ceil(timeRemaining / 1000)}
        </span>
      </div>
    </div>
  );
};

export default RenderTimer;